import { CSSObject } from '@emotion/react';

export const buttonIncreaseProps: CSSObject = {
  variant: 'secondary',
};
